// extracted by mini-css-extract-plugin
export default {"productGallery":"II-z","inQuickShop":"JI-z"};